import React, { useEffect } from "react";
import NormalInput from "component/common/NormalInput/index";
import PasswordInput from "component/common/PasswordInput";
import ErrorMessage from "component/common/ErrroMessage/index";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Toast } from "utils/toast";
import { signIn } from "service/Auth";

import styles from "./Login.module.scss";
import jwtDecode from "jwt-decode";

const Login = () => {
  const history = useHistory();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  useEffect(() => {
    window.addEventListener("keypress", handleKeyPress);
    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit(onSubmit)();
    }
  };

  const onSubmit = async (data) => {
    try {
      let response = await signIn(data);
      if (response.status == 200) {
        await localStorage.setItem("token", response.data.data.token);
        await localStorage.setItem(
          "user",
          JSON.stringify(jwtDecode(response.data.data.token))
        );
        Toast({ type: "success", message: "Login successfully" });
        history.push("/admin/dashboard");
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <div className={styles.login}>
      <div className={styles.login_title}>
        <b>LOGIN</b>
      </div>
      <div className={styles.login_field}>
        <NormalInput
          register={register("emailId", {
            required: true,
            pattern:
              /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
          })}
          error={errors.emailId}
          label="Email ID"
          placeholder="Email ID"
        />
        <ErrorMessage
          error={errors.emailId}
          message={{
            required: "Please enter email id",
            pattern: "Please enter valid email id",
          }}
        />
      </div>
      <div className={styles.login_field}>
        <PasswordInput
          register={register("password", {
            required: true,
          })}
          label="Password"
          placeholder="Enter your password"
          error={errors.password}
        />
        <ErrorMessage
          error={errors.password}
          message={{
            required: "Please enter password",
          }}
        />
      </div>

      <div className={styles.forgot_password}>
        <span onClick={() => history.push("/auth/reset-password")}>
          Reset Your Password?
        </span>
        {/* <span onClick={() => history.push("/auth/forgot-password")}>
          Change Password?
        </span> */}
      </div>

      <div className={styles.btn_login}>
        <button onClick={handleSubmit(onSubmit)}>LOGIN</button>
      </div>
    </div>
  );
};

export default Login;
